// This is the recommended fix for a code coverage bug :(
var RateCodes;

(function (RateCodes) {
  RateCodes["GUARANTEED_SERVICE"] = "PMT";
  RateCodes["LIFT_GATE"] = "LFT";
  RateCodes["INSIDE_PICKUP"] = "IPU";
  RateCodes["LIMITED_ACCESS_PICKUP"] = "PLA";
  RateCodes["RESIDENTIAL_PICKUP"] = "REP";
  RateCodes["INSIDE_DESTINATION"] = "IDL";
  RateCodes["RESIDENTIAL_DESTINATION"] = "RES";
  RateCodes["EXCISE_TAX"] = "EXT";
  RateCodes["LIMITED_ACCESS_DESTINATION"] = "DLA";
  RateCodes["APPOINTMENT_FEE"] = "APT";
  RateCodes["INSURANCE_PREMIUM"] = "455";
  RateCodes["CARRIER_TERMINAL_PICKUP"] = "PKU";
  RateCodes["CARRIER_TERMINAL_DROP_OFF"] = "DRP";
  RateCodes["SCHEDULE_PICKUP"] = "540";
  RateCodes["WEIGHT_VERIFICATION_CHARGE"] = "WTV";
  RateCodes["LTL_RECLASSIFICATION"] = "LRC";
  RateCodes["WEIGHT_AND_CLASS"] = "WAC";
  RateCodes["INSPECTION_FEE"] = "IAC";
  RateCodes["INSPECTION_FEE_2"] = "CFE";
  RateCodes["RECONSIGNMENT_CHARGE"] = "RCC";
})(RateCodes || (RateCodes = {}));

var RateCodeRDN;

(function (RateCodeRDN) {
  RateCodeRDN[RateCodeRDN["GUARANTEED_SERVICE"] = 683] = "GUARANTEED_SERVICE";
  RateCodeRDN[RateCodeRDN["LIFT_GATE"] = 659] = "LIFT_GATE";
  RateCodeRDN[RateCodeRDN["INSIDE_PICKUP"] = 652] = "INSIDE_PICKUP";
  RateCodeRDN[RateCodeRDN["LIMITED_ACCESS_PICKUP"] = 3454] = "LIMITED_ACCESS_PICKUP";
  RateCodeRDN[RateCodeRDN["RESIDENTIAL_PICKUP"] = 699] = "RESIDENTIAL_PICKUP";
  RateCodeRDN[RateCodeRDN["INSIDE_DESTINATION"] = 646] = "INSIDE_DESTINATION";
  RateCodeRDN[RateCodeRDN["RESIDENTIAL_DESTINATION"] = 700] = "RESIDENTIAL_DESTINATION";
  RateCodeRDN[RateCodeRDN["LIMITED_ACCESS_DESTINATION"] = 3453] = "LIMITED_ACCESS_DESTINATION";
  RateCodeRDN[RateCodeRDN["EXCISE_TAX"] = 3595] = "EXCISE_TAX";
  RateCodeRDN[RateCodeRDN["APPOINTMENT_FEE"] = 566] = "APPOINTMENT_FEE";
  RateCodeRDN[RateCodeRDN["INSURANCE_PREMIUM"] = 520] = "INSURANCE_PREMIUM";
  RateCodeRDN[RateCodeRDN["CARRIER_TERMINAL_PICKUP"] = 5379] = "CARRIER_TERMINAL_PICKUP";
  RateCodeRDN[RateCodeRDN["CARRIER_TERMINAL_DROP_OFF"] = 5378] = "CARRIER_TERMINAL_DROP_OFF";
  RateCodeRDN[RateCodeRDN["PICKUP_SURCHARGE"] = 527] = "PICKUP_SURCHARGE";
  RateCodeRDN[RateCodeRDN["WEIGHT_VERIFICATION_CHARGE"] = 756] = "WEIGHT_VERIFICATION_CHARGE";
  RateCodeRDN[RateCodeRDN["LTL_RECLASSIFICATION"] = 3243] = "LTL_RECLASSIFICATION";
  RateCodeRDN[RateCodeRDN["WEIGHT_AND_CLASS"] = 5618] = "WEIGHT_AND_CLASS";
  RateCodeRDN[RateCodeRDN["INSPECTION_FEE"] = 3649] = "INSPECTION_FEE";
  RateCodeRDN[RateCodeRDN["INSPECTION_FEE_2"] = 4073] = "INSPECTION_FEE_2";
  RateCodeRDN[RateCodeRDN["RECONSIGNMENT_CHARGE"] = 695] = "RECONSIGNMENT_CHARGE";
})(RateCodeRDN || (RateCodeRDN = {}));

export { RateCodeRDN, RateCodes };
//# sourceMappingURL=index.es.js.map
